import BaseModel from './base';
import PollQuestionModel from './poll-question';

import { QUESTION_TYPES } from '@/modules/Poll/constants';

export default class PollAnswers extends BaseModel {
  constructor(answer, url) {
    super(answer, url);

    this.question = new PollQuestionModel(answer?.question || {});
    this.documents = answer?.documents || [];
    this.images = answer?.images || [];
    this.links = answer?.links || [];
    this.event_stage_id = answer?.event_stage_id || null;
    this.owner_id = answer?.owner_id || null;
    this.poll_id = answer?.poll_id || null;
    this.poll_journal_id = answer?.poll_journal_id || null;
    this.question_id = answer?.question_id || null;
    this.question_type = answer?.question_type ? QUESTION_TYPES[answer.question_type] : {};
    this.score = answer?.score || 0;
    this.created_at = answer?.created_at || null;
    this.response = {
      options: [],
      images: this.images || [],
      links: this.links || [],
      documents: this.documents || [],
      text: '',

      ...answer?.response || {},
    };
  }
}
